import React from "react";

import SearchImage from "../images/Search.png";
import PaginationBar from "../../InventoryManagement/components/Common/PaginationBar";

const currency = (n) =>
  new Intl.NumberFormat(undefined, { maximumFractionDigits: 0 }).format(n);

export const LoanRequestsTable = ({
  data,
  loading = false,
  page,
  pageCount,
  onPageChange,
  onDetailsClick,
  error,
  totalCount,
}) => {
  const headers = [
    "Merchant Wallet",
    "Merchant Name",
    "MDO Employee ID",
    "Merchant Age",
    "Loan Amount",
    "Request Time",
    "Request Status",
    "",
  ];
  const SkeletonRow = () => (
    <tr className="row">
      {headers.map((_, i) => (
        <td key={i} className="cell">
          <div className="skeleton" />
        </td>
      ))}
    </tr>
  );
  return (
    <div className="wrapper">
      <div className="loan-req-table-container">
        {loading ? (
          <table className="loan-req-table">
            <thead>
              <tr className="loan-req-header-row">
                {headers.map((h) => (
                  <th key={h} className="loan-req-header-cell">
                    {h}
                  </th>
                ))}
              </tr>
            </thead>
            <tbody>
              {Array.from({ length: 10 }).map((_, i) => (
                <SkeletonRow key={`skeleton-${i}`} />
              ))}
            </tbody>
          </table>
        ) : error ? (
          <div className="error-container">
            <img src={SearchImage} alt="" className="error-image" />
            <h2 className="error-title">Error fetching data</h2>
            <p className="error-message">Please try again.</p>
          </div>
        ) : !loading && data.length === 0 ? (
          <div className="error-container">
            <img src={SearchImage} alt="" className="error-image" />
            <h2 className="error-title">No Data Found</h2>
            <p className="error-message">Please try again.</p>
          </div>
        ) : (
          <table className="loan-req-table">
            <thead>
              <tr className="loan-req-header-row">
                {headers.map((h) => (
                  <th key={h} className="loan-req-header-cell">
                    {h}
                  </th>
                ))}
              </tr>
            </thead>
            <tbody>
              {data.map((row, idx) => (
                <tr
                  key={`${row.loan_request_id || "loan"}-${idx}`}
                  className="loan-req-row"
                >
                  <td className="loan-req-cell">{row.wallet_number || "-"}</td>
                  <td
                    className="loan-req-cell loan-req-cell-truncate"
                    title={row.merchant_name || "-"}
                  >
                    {row.merchant_name || "-"}
                  </td>
                  <td className="loan-req-cell loan-req-cell-thin">
                    {row.mdo_employee_id || "-"}
                  </td>
                  <td className="loan-req-cell loan-req-cell-thin">
                    {row.merchant_age || "-"}
                  </td>
                  <td className="loan-req-cell">{currency(row.loan_amount)}</td>
                  <td className="loan-req-cell loan-req-cell-thin">
                    {row.request_time || "-"}
                  </td>
                  <td className="loan-req-cell">
                    <StatusPill status={row.request_status} />
                  </td>
                  <td className="loan-req-cell">
                    <button
                      className="details-button"
                      onClick={() => {
                        onDetailsClick(row.loan_request_id);
                      }}
                    >
                      Details
                    </button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        )}
      </div>

      {pageCount > 1 && !loading && (
        <PaginationBar
          page={page}
          setPage={onPageChange}
          totalPages={pageCount}
          totalCount={totalCount}
        />
      )}
    </div>
  );
};

const StatusPill = ({ status }) => {
  let uiStatus = "";
  let tone = "";
  switch (status?.toLowerCase()) {
    case "pending @ mdo":
      uiStatus = "Pending @ MDO";
      tone = "status-pill-mdo";
      break;
    case "pending @ om":
      uiStatus = "Pending @ OM";
      tone = "status-pill-om";
      break;
    case "approved":
      uiStatus = "Approved";
      tone = "status-pill-approved";
      break;
    case "rejected @ mdo":
      uiStatus = "Rejected @ MDO";
      tone = "status-pill-rejected";
      break;
    case "rejected @ om":
      uiStatus = "Rejected @ OM";
      tone = "status-pill-rejected";
      break;
    default:
      uiStatus = status;
      tone = "";
  }
  return <span className={`status-pill ${tone}`}>{uiStatus}</span>;
};

export default LoanRequestsTable;
